'use client';

import { SearchIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useCommandPaletteContext } from './use-command-palette-context';

type VariantType = 'pill' | 'icon';

interface ICommandPaletteTriggerButtonProps {
  variant?: VariantType;
  className?: string;
}

const PILL_CLASSES =
  'cm-press flex w-full max-w-xl items-center gap-3 rounded-full border border-border bg-card px-4 py-2.5 text-sm text-muted-foreground hover:bg-accent hover:border-foreground/20';
const ICON_CLASSES =
  'cm-press flex size-12 items-center justify-center rounded-lg text-foreground hover:bg-accent';

export function CommandPaletteTriggerButton({
  variant = 'pill',
  className,
}: ICommandPaletteTriggerButtonProps): React.JSX.Element {
  const t = useTranslations('commandPalette.trigger');
  const { openPalette } = useCommandPaletteContext();
  const isIcon = variant === 'icon';
  const baseClass = isIcon ? ICON_CLASSES : PILL_CLASSES;
  return (
    <button
      type="button"
      onClick={() => openPalette()}
      aria-label={t('ariaLabel')}
      className={className ? `${baseClass} ${className}` : baseClass}
    >
      <SearchIcon className="size-5 shrink-0" aria-hidden />
      {!isIcon && (
        <>
          <span className="flex-1 text-start">{t('placeholder')}</span>
          <kbd className="hidden rounded border border-border bg-muted px-1.5 py-0.5 text-xs text-muted-foreground sm:inline">
            {t('shortcutHint')}
          </kbd>
        </>
      )}
    </button>
  );
}
